import { render, staticRenderFns } from "./ModuleUpload.vue?vue&type=template&id=83a136c8"
import script from "./ModuleUpload.vue?vue&type=script&lang=js"
export * from "./ModuleUpload.vue?vue&type=script&lang=js"
import style0 from "./ModuleUpload.vue?vue&type=style&index=0&id=83a136c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports